import { createContext, useContext } from 'react';
import { MeuEscopo } from './api';

// Escopo do usuário, carregado uma vez pelo guard. Serve só para a UI decidir
// o que mostrar — todo bloqueio real acontece no backend.
export const ServiceLevelContext = createContext<MeuEscopo | null>(null);

export const useEscopo = () => useContext(ServiceLevelContext);

// Nível 1: só agregados · 2: recortes e resumos · 3: drill até pedido/item
export const usePodeVerDetalhe = (minimo: 2 | 3) => {
  const escopo = useEscopo();
  return (escopo?.detail_level ?? 3) >= minimo;
};
